/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TurniResDto } from '../../models/turni-res-dto';

export interface TurniControllerDeleteTurno$Params {
  idPianificazione: number;
}

export function turniControllerDeleteTurno(
  http: HttpClient,
  rootUrl: string,
  params: TurniControllerDeleteTurno$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurniResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    turniControllerDeleteTurno.PATH,
    'delete',
  );
  if (params) {
    rb.path('idPianificazione', params.idPianificazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TurniResDto>;
      }),
    );
}

turniControllerDeleteTurno.PATH = '/admin/turni/id/{idTurno}';
